import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import { enquireScreen } from "enquire-js";
import { ConfigProvider } from "antd";
// import { Radio } from "antd";
// import enUS from "antd/lib/locale/en_US";
import fa_IR from "antd/lib/locale/fa_IR";
import moment from "moment";

import Header from "./Components/Nav";
import Footer from "./Components/Footer";
import { Footer10DataSource } from "./Components/data.source";
import Home from "./Home";
import OnlineClass from "./online-class";
import Plans from "./plans";
import SchoolApp from "./school-app";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import Rules from "./Rules";
import PrivacyPolicy from "./PrivacyPolicy";
import Customers from "./Customers";
import Status from "./Status";
import MobileAppPage from "./MobileAppPage";

moment.locale("en");

let isMobile;
enquireScreen(b => {
  isMobile = b;
});
const { location = {} } = typeof window !== "undefined" ? window : {};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      show: !location.port, // 如果不是 dva 2.0 请删除
      locale: fa_IR,
      direction: "rtl"
    };
  }

  changeLocale = e => {
    const localeValue = e.target.value;

    if (localeValue.locale === "fa") {
      this.setState({
        locale: localeValue,
        direction: "rtl"
      });
    } else {
      this.setState({
        locale: localeValue,
        direction: "ltr"
      });
    }
    // if (!localeValue) {
    //   moment.locale('en');
    // } else {
    //   moment.locale('zh-cn');
    // }
  };
  // scroll to top on pages rendering
  scrollStep() {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  // async componentDidMount() {
  //   this.scrollStep();
  // }

  componentDidMount() {
    enquireScreen(b => {
      this.setState({ isMobile: !!b });
    });
    if (location.port) {
      setTimeout(() => {
        this.setState({
          show: true
        });
      }, 500);
    }
  }

  render() {
    const { locale } = this.state;
    const { direction } = this.state;
    return (
      <Router>
        {/* <div className="change-locale">
          <Radio.Group value={locale} onChange={this.changeLocale}>
            <Radio.Button key="en" value={enUS}>
              En
            </Radio.Button>
            <Radio.Button key="fa" value={fa_IR}>
              فا
            </Radio.Button>
          </Radio.Group>
        </div> */}

        <div>
          <ConfigProvider locale={locale} direction={direction}>
            <Header isMobile={this.isMobile} />
            <main className="page-wrapper">
              <Route exact path="/" component={Home} />
              <Route exact path="/school-app" component={SchoolApp} />
              <Route exact path="/about" component={AboutUs} />
              <Route exact path="/rules" component={Rules} />
              <Route exact path="/status" component={Status} />
              <Route exact path="/customers" component={Customers} />

              <Route exact path="/privacy-policy" component={PrivacyPolicy} />
              <Route exact path="/contact" component={ContactUs} />
              <Route exact path="/online-class" component={OnlineClass} />
              <Route exact path="/online-class/plans" component={Plans} />
              <Route exact path="/app-page" component={MobileAppPage} />

            </main>

            <Footer dataSource={Footer10DataSource} isMobile={this.isMobile} />
          </ConfigProvider>
        </div>
      </Router>
    );
  }
}

export default App;
